"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const IComponentContext_1 = require("./IComponentContext");
class ComponentContextBase {
    constructor() {
        this._state = IComponentContext_1.ComponentContextReadyState.Loading;
    }
    get readyState() {
        return this._state;
    }
}
exports.ComponentContextBase = ComponentContextBase;
//# sourceMappingURL=ComponentContextBase.js.map